import React, { useState } from 'react'
import { connect } from 'react-redux'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

const DeleteMindfile = ({ deleteMindfile }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Typography variant="subtitle1" gutterBottom>
        Mindfile
      </Typography>
      <Box>
        <Typography style={{ display:'inline-block', paddingRight: 16 }}>Delete this mindfile:</Typography>
        <Button variant="contained" color="primary" onClick={ () => setOpen(true) }>Delete</Button>
      </Box>
      <Modal open={ open } onClose={() => setOpen(false)}>
        <Box style={{ width: '100dvw', height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Card>
            <CardContent>
              <Typography variant="h6">Do you want to delete this mindfile? This action cannot be undone.</Typography>
              <Box mt={ 3 } >
                <Button variant="contained" color="primary" onClick={ deleteMindfile }>Delete</Button>
                <Button variant="contained" color="secondary" onClick={ () => setOpen(false) } style={{ marginLeft: 16 }}>Cancel</Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Modal>
    </>
  )
}

const mapStateToProps = state => ({
  user: state.auth,
});

export default connect(mapStateToProps)(DeleteMindfile)